<script lang="ts">
    import { remoteVideoStore, remoteAudioStore } from "../../stores/remoteVideoStore.js";
    import { addToast } from "../../stores/toastStore.js";

    let videoEl: HTMLVideoElement;
    let audioEl: HTMLAudioElement;

    $: if (videoEl && $remoteVideoStore) {
        videoEl.srcObject = $remoteVideoStore;
        console.log('[CallRemoteVideo] srcObject assigned for videoEl');
    }

    $: if (audioEl && $remoteAudioStore) {
        audioEl.srcObject = $remoteAudioStore;
        console.log('[CallRemoteVideo] srcObject assigned for audioEl');
    }

    function resumePlayback() {
        videoEl?.play().catch(() => {});
        audioEl?.play().catch(() => {});
    }

    document.addEventListener('click', resumePlayback, { once: true });
</script>

<div class="flex justify-center relative">
    {#if $remoteVideoStore}
        <video
            bind:this={videoEl}
            class='remote-video'
            autoplay
            playsinline
            muted
        ></video>
    {/if}

    {#if !$remoteVideoStore && $remoteAudioStore}
        <audio bind:this={audioEl} autoplay></audio>
    {/if}
</div>

<style>
    .video-overlay,
    .audio-overlay {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.65);
        color: white;
        padding: 12px 18px;
        border-radius: 10px;
        font-weight: 600;
        z-index: 5;
        text-align: center;
    }
    .remote-video {
        width: 70%;
        max-width: 800px;
        max-height: 80vh;
        border-radius: 8px;
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
    }

    @media (max-width: 768px) {
        .remote-video {
            width: 100%;
            max-height: 60vh;
        }
    }
</style>

